import { put, call, select } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';
import {
  addFarmToFavouritesError,
  addFarmToFavouritesSuccess,
  favouriteFarmsSelectors,
  getFavouriteFarmsError,
  getFavouriteFarmsSuccess,
  MAXIMUM_NUMBER_OF_FAVOURITE_FARMS_ALLOWED,
  removeFarmFromFavouritesError,
  removeFarmFromFavouritesSuccess,
} from '../../reducers/favouriteFarmsSlice';
import { api } from '../../api/lelyBackend/favouriteFarmsApi';
import {
  resetNetworkErrorMessage,
  setGenericError,
} from '../../reducers/networkErrorSlice';

export function* addFarmToFavouritesSaga(action) {
  try {
    const currentFavourites = yield select(
      favouriteFarmsSelectors.selectFavouriteFarms,
    );
    const numberOfFavouritesAtTheMoment = Object.keys(currentFavourites).length;
    const isMaximumNumberOfFavouritesReachedAlready =
      numberOfFavouritesAtTheMoment >=
      MAXIMUM_NUMBER_OF_FAVOURITE_FARMS_ALLOWED;
    if (isMaximumNumberOfFavouritesReachedAlready) {
      yield put(
        setGenericError(
          'The maximum amount of favourite farms has been reached.',
        ),
      );
    } else {
      yield call(api.addFarmToFavourites, action.payload);
      yield put(resetNetworkErrorMessage());
      yield put(addFarmToFavouritesSuccess(action.payload));
    }
  } catch (error: any) {
    yield put(resetNetworkErrorMessage());
    yield put(addFarmToFavouritesError(error));
  }
}

export function* removeFarmFromFavouritesSaga(action) {
  try {
    yield call(api.removeFarmFromFavourites, action.payload);
    yield put(removeFarmFromFavouritesSuccess(action.payload));
    yield put(resetNetworkErrorMessage());
  } catch (error: any) {
    yield put(removeFarmFromFavouritesError(error));
  }
}

export function* getFavouriteFarmsSaga() {
  try {
    const response: AxiosResponse<string[]> = yield call(api.getFavouriteFarms);
    yield put(getFavouriteFarmsSuccess(response.data));
    yield put(resetNetworkErrorMessage());
  } catch (error: any) {
    yield put(getFavouriteFarmsError(error));
  }
}
